import { OPEN_CART_PARAM } from '../utils/cart-drawer-params';

const RETURN_URL_PARAM = 'return_to';

/**
 * Appends the current page as `return_to` to sign-in links at click time.
 * Delegated, because links may be rendered inside AJAX-refreshed cart fragments,
 * where the server cannot know which page the user is actually on.
 * Links inside the cart drawer also ask the return page to reopen the drawer.
 */
export default function () {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a.js-auth-return');
    if (!link || !link.href) return;

    try {
      const url = new URL(link.href);
      const returnUrl = new URL(window.location.href);
      if (link.closest('.cart-drawer')) {
        returnUrl.searchParams.set(OPEN_CART_PARAM, '1');
      }
      url.searchParams.set(RETURN_URL_PARAM, returnUrl.toString());
      link.href = url.toString();
    } catch (e) {
      // keep the original href on malformed URLs
    }
  });
}
